<!-- Vertical Menu -->
<ng-container *ngIf="layout === 'vertical'">
  <ng-container *ngFor="let item of menu">
    <!-- section -->
    <li core-menu-vertical-section *ngIf="item.type == 'section'" [item]="item" class="navigation-header"></li>

    <!-- sub-menu item/collapsible of sections  -->
    <ng-container *ngIf="item.type == 'section'">
      <ng-container *ngFor="let item of item.children">
        
        <!-- ticker -->
        <li 
        app-ticker
        *ngIf="item.type == 'ticker'
        "></li>

        <!-- crypto ticker -->
        <li 
        app-crypto
        *ngIf="item.type == 'crypto'
        "></li>

        <!-- nft ticker -->
        <li 
        app-nft-search
        *ngIf="item.type == 'nft'
        "></li>

        <!-- wallet -->
        <li
        app-wallet
        *ngIf="item.type == 'wallet'">
        </li>

        <!-- clickable -->
        <li
        core-menu-vertical-item
        *ngIf="item.type == 'clickable'"
        (click)="clickable(item)"
        [item]="item"
        [ngClass]="{ disabled: item.disabled === true }"
      ></li>

        <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
        <li
          core-menu-vertical-item
          *ngIf="
            item.type == 'item' && (item.disabled === false || item.disabled === undefined)
          "
          [item]="item"
          [ngClass]="{ disabled: item.disabled === true }"
          [routerLink]="item.openInNewTab ? [] : [item.url]"
          [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
        ></li>

        <!-- item disable -->
        <li
          core-menu-vertical-item
          *ngIf="item.type == 'item' && item.disabled === true"
          [item]="item"
          [ngClass]="{ disabled: item.disabled === true }"
          (click)="checking(item)"></li>
        <!-- collapsible -->
        <li
          core-menu-vertical-collapsible
          *ngIf="item.type == 'collapsible'"
          [item]="item"
          class="nav-item has-sub"
        ></li>
      </ng-container>
    </ng-container>

    <!-- item -->
    <li
      core-menu-vertical-item
      *ngIf="
        item.type == 'item' && (item.disabled === false || item.disabled === undefined)
      "
      [item]="item"
      [ngClass]="{ disabled: item.disabled === true }"
      [routerLink]="item.openInNewTab ? [] : [item.url]"
      [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
    ></li>

      <!-- item disable -->
      <li
      core-menu-vertical-item
      *ngIf="
        item.type == 'item' && item.disabled === true
      "
      [item]="item"
      [ngClass]="{ disabled: item.disabled === true }"
      (click)="checking()"
    ></li>
    <!-- collapsible -->
    <li core-menu-vertical-collapsible *ngIf="item.type == 'collapsible'" [item]="item" class="nav-item has-sub"></li>
  </ng-container>
</ng-container>
<!--/ Vertical Menu -->

<!-- Horizontal Menu -->
<ng-container *ngIf="layout === 'horizontal'">
  <ng-container *ngFor="let item of menu">
    <!-- section -->
    <li core-menu-horizontal-collapsible *ngIf="item.type == 'section'" [item]="item" class="dropdown nav-item"></li>

    <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
    <li
      core-menu-horizontal-item
      *ngIf="
        item.type == 'item' && item.role == undefined
      "
      [item]="item"
      [ngClass]="{ disabled: item.disabled === true }"
      [routerLink]="item.openInNewTab ? [] : [item.url]"
      [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
    ></li>

    <!-- collapsible -->
    <li
      core-menu-horizontal-collapsible
      *ngIf="item.type == 'collapsible'"
      [item]="item"
      class="dropdown dropdown-submenu"
    ></li>
  </ng-container>
</ng-container>
<!--/ Horizontal Menu -->
